import { render, staticRenderFns } from "./SettingPanel.vue?vue&type=template&id=70e3930b&scoped=true&"
import script from "./SettingPanel.vue?vue&type=script&lang=js&"
export * from "./SettingPanel.vue?vue&type=script&lang=js&"
import style0 from "./SettingPanel.vue?vue&type=style&index=0&id=70e3930b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e3930b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
